import { Injectable ,Component, OnDestroy, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService  {
  private user = new BehaviorSubject(null);
  private subMenus = new BehaviorSubject(null);
  private datePicker: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private date: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private smallScreenMenuState: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  constructor() { }

  getUser(): Observable<any> {
    return this.user.asObservable();
  }

  saveUser(user) {
    this.user.next(user);
  }

  getSubMenus() {
    return this.subMenus.asObservable();
  }

  saveSubMenus(subMenus) {
    this.subMenus.next(subMenus);
  }

  toggleDatePicker(bool){
    this.datePicker.next(bool);
  }

  getDatePickerSate(){
    return this.datePicker.asObservable();
  }

  setDate(date){
    this.date.next(date);
  }

  getDate(){
    return this.date.asObservable();
  }

  getSmallScreenMenuState(): Observable<any> {
    return this.smallScreenMenuState.asObservable();
  }

  setSmallScreenMenuState(b) {
    this.smallScreenMenuState.next(b);
  }
}
